import { FC, useMemo } from "react";
// Redux
import { useAppDispatch, useAppSelector } from "hooks/useStore";
import { resultActions } from "store/result/resultSlice";
import { getSelectedTab } from "store/result/resultSelectors";
import { selectQuiz } from "store/quiz/quizzesSelectors";
import AnswersTabsTypes from "types/AnswersTabs";
import QuizTypes from "types/QuizTypes";
// MUI
import { Tab, Tabs } from "@material-ui/core";
// i18next
import { useTranslation } from "react-i18next";
import i18n from "i18n";


const AnswersTabs:FC = () => {
  const { t } = useTranslation();

  const dispatch = useAppDispatch();

  const quiz = useAppSelector(selectQuiz);
  const selectedTab = useAppSelector(getSelectedTab);

  const tabs = useMemo(() => [
    { value: AnswersTabsTypes.Answers, label: t('labels.main'), hidden: quiz?.type === QuizTypes.Survey },
    { value: AnswersTabsTypes.AdditionalAnswers, label: t('labels.additionalAnswers') }
    // eslint-disable-next-line
  ], [i18n.language])

  const onChangeTab = (_:any, nextTab:AnswersTabsTypes) => dispatch(resultActions.setSelectedTab(nextTab));

  return (
    <Tabs
      value={selectedTab}
      indicatorColor="primary"
      textColor="inherit"
      onChange={onChangeTab}
      aria-label="Answers tabs"
    >
      {tabs.map(tab => {
        if (tab.hidden) return null;
        return <Tab key={tab.value} label={tab.label} value={tab.value} />;
      })}
    </Tabs>
  );
}
 
export default AnswersTabs;